import React, { useCallback, useEffect, useRef, useMemo, useState } from 'react';
import Axios from '../../../axios-proas'
import CloseIcon from '@mui/icons-material/Close';
import AddIcon from '@mui/icons-material/Add';
import { EntOwnersSelect, AddOwner, SearchOwner, SelectOwnersHeader, SelectOwnersItem, SelectOwnersItems, SelectOwnersList, ItemLabel, ItemCode, SelectContainerLevel, SelectContainer, SelectOwnersListLevel,SelectOwnersItemsLevel } from './DropDown.styled';
import { useTranslation } from 'react-i18next';
import { PrimaryBtnOutlineAction,  SearchInput, SearchInputContainer,PrimaryBtnOutlineActionModal,SecondaryBtnOutlineActionModal  } from "../../../styles/Common";
import MandatoryMarker from '../../UI/MandatoryMarker';
import ArrowCircleDownIcon from '@mui/icons-material/ArrowCircleDown';
import AddCircleIcon from '@mui/icons-material/AddCircle';
import CancelIcon from '@mui/icons-material/Cancel';
import DoneIcon from '@mui/icons-material/Done';
import SearchIcon from '@mui/icons-material/Search';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {faUserGear, faCircleInfo, faCirclePlus } from '@fortawesome/free-solid-svg-icons'
import axios from 'axios';
import Draggable from "react-draggable";

import { Resizable } from 're-resizable';
function DropDown({ endpoint, listItems, entities, addEntitiesUser, requestParams, searchQuery, setSearchQuery }) {
    const {t} = useTranslation();
    const [showEntityModal, setShowEntityModal] = useState(false);
    
    const[items, setItems] = useState(listItems)
    const selectRef = useRef();
    const clickOutSideHandler = e => {
        if(selectRef.current.contains(e.target)) {        
            return
        }
        setShowEntityModal(false)
    } 
   



    useEffect(() => {
        setItems(listItems)
        document.addEventListener("mousedown", clickOutSideHandler);
        return () => {
            document.removeEventListener("mousedown", clickOutSideHandler);
        }
    }, [listItems])

   
    const SelectEntity = (entity) => {    
            let entityIndex = items?.findIndex(row => row.id === entity.id);
            let selectedTemp = [...items];
            if (entityIndex < 0)
                selectedTemp = [...items, entity];
            setItems(selectedTemp)      
    }
    const deleteItem = (en) => {  
        let userEntity = [...items]
        let entityIndex = items.findIndex(ent => ent.id === en.id);
        if(entityIndex >=0 ){
            userEntity.splice(entityIndex, 1)
        }
        setItems(userEntity)
    }

    


   
  return ( 
      <>       
          <AddOwner ref={selectRef} >
              <FontAwesomeIcon icon={faCirclePlus} style={{ color: "#2174b980", fontSize: "1rem"}} onClick={() => setShowEntityModal(!showEntityModal)}/>
            {
                showEntityModal && (
                      <Draggable >
                          <SelectContainerLevel >
                              <Resizable
                                  defaultSize={{ width: 320, height: 250 }}
                                  minWidth={330}
                                  minHeight={250}
                                  maxWidth="80vw"
                                  maxHeight="80vh"
                              >
                                  <small style={{ fontSize: "0.75rem", color: "#888", paddingLeft: "7px" }}>
                                      {("Vous pouvez déplacer ou redimensionner cette fenêtre")}
                                  </small>
                    <SearchOwner>
                        <SearchInput 
                            placeholder="Rechercher"
                            type="text"
                            onChange={(e) => setSearchQuery(e.target.value)} 
                            value={searchQuery || ''}
                        />
                        <SearchIcon style={{fontSize: "0.9rem"}}/>
                    </SearchOwner>
                    <SelectOwnersListLevel>                  
                         <SelectOwnersItemsLevel >
                                  {
                                      entities?.length > 0 ? entities.map(entity => (
                                         <SelectOwnersItem key={entity?.id} onClick={() => SelectEntity({ id: entity.id, raisonSociale: entity.raisonSociale, libelle: entity.libelle, code: entity.code, libelleCourt: entity.libelleCourt, new: true })}>
                                              <input type='checkbox' disabled={false } name={entity.id} checked={items?.findIndex(row => row.id === entity.id) >= 0} style={{ marginRight: '0.5rem' }} 
                                                 onChange={(e) =>{
                                                     items?.findIndex(row => row.id === entity.id) >= 0 ? deleteItem(entity) : SelectEntity({ id: entity.id, raisonSociale: entity.raisonSociale, libelle: entity.libelle, code: entity.code, libelleCourt: entity.libelleCourt, new : true})}}
                                                />
                                            <ItemLabel>{entity?.raisonSociale}</ItemLabel>
                                            <ItemCode>{entity?.code}</ItemCode>
                                        </SelectOwnersItem>
                                        )) : <div style={{whiteSpace: "nowrap"}}>
                                            {t('mandat:noAgencies', "Aucune donneé à afficher")}  
                                         </div>
                                  }
                        </SelectOwnersItemsLevel>
                    
                                    <div  style={{display: "flex",justifyContent: "center",width: "auto"}}>
                                        <PrimaryBtnOutlineActionModal>
                                      <DoneIcon onClick={e => { addEntitiesUser(items), setShowEntityModal(false), setSearchQuery("")}}/>
                                        </PrimaryBtnOutlineActionModal>
                                               
                                        <SecondaryBtnOutlineActionModal>
                                      <CloseIcon onClick={e => { setShowEntityModal(false), setSearchQuery("") }}/>
                                        </SecondaryBtnOutlineActionModal>
                                       
                                    </div>
                     </SelectOwnersListLevel>
                    </Resizable>
                   </SelectContainerLevel>                        
                   </Draggable>
                )
            }
               </AddOwner>      
        


      </>
  );
}

export default DropDown;
